import { Tabs, TabsList, TabsTrigger, TabsContent } from "./Tabs"

export { Tabs, TabsList, TabsTrigger, TabsContent }
